import {yupResolver} from '@hookform/resolvers/yup'
import {QueryClientProvider} from '@tanstack/react-query'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {ReactElement} from 'react'
import {useMemo} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

import {Form} from './components/form/Form@desktop'
import {useDefaultValuesAndDraftSync} from './components/form/hooks/use-default-values-and-draft-sync'
import {ConfigProvider} from './contexts'
import {queryClient} from './lib/query-client'
import {getFormValidationSchema} from './lib/validation'
import type {OrderFormProps, OrderFormState} from './types'

export function OrderForm(props: OrderFormProps): ReactElement {
  const {config} = props
  const i18n = useI18n()
  const {defaultValues} = useDefaultValuesAndDraftSync(config)

  const resolver = useMemo(
    () =>
      yupResolver(
        getFormValidationSchema(i18n, config),
        {},
        {
          mode: 'async',
        },
      ),
    [i18n, config],
  )

  const form = useForm<OrderFormState>({
    defaultValues,
    resolver,
    mode: 'onBlur',
  })

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider {...config}>
        <FormProvider {...form}>
          <Form />
        </FormProvider>
      </ConfigProvider>
    </QueryClientProvider>
  )
}
